import { lazy } from 'react';

export const BlogDetailPage = lazy(() => import('./BlogDetailPage'));
